import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class StripeService {
  entity: string = "/stripes";

  constructor(private http: HttpClient, private authService: AuthService) {}

  create(data: any, jwt: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "?populate=*",
      {
        data: data,
      },
      {
        headers: {
          Authorization: "Bearer " + jwt,
          "Content-Type": "application/json",
        },
      }
    );
  }

  setupStripeAccount(): Observable<any> {
    let body = this.authService.currentUserValue.is_connect_with
      ? { profile: this.authService.currentUserValue?.profile?.id }
      : {};

    return this.http.post(
      environment.api + this.entity + "/setup-stripe-account",
      body,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  createSubscription(data: any): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/create-subscription",
      data,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  cancel_subscription_at_period_end(values: any): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/cancel-period-end",
      values,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  check_payouts_enabled(): Observable<any> {
    let filters = this.authService.currentUserValue.is_connect_with
      ? "?user=" + this.authService.currentUserValue?.id
      : "";

    return this.http.get(
      environment.api + this.entity + "/check-payouts-enabled" + filters,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  export_invoices(filters: string): Observable<any> {
    return this.http.get(
      environment.api + this.entity + "/export-invoices?" + filters,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  delete_file_invoices(path: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/delete-file",
      { path: path },
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  invoices(
    subscription_token: string,
    user: string,
    more_params?: Array<any>
  ): Observable<any> {
    var body = { subscription: subscription_token, user: user };
    more_params.forEach((item) => {
      body[item.key] = item.value;
    });
    return this.http.post(environment.api + this.entity + "/invoices", body, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
        "Content-Type": "application/json",
      },
    });
  }

  remove_promotion_code(id: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/remove-promotion-codes/" + id,
      {},
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  mes_paiements_method(more_params?: Array<any>): Observable<any> {
    let filters = "?";
    more_params?.forEach((item) => {
      filters += item.key + "=" + item.value + "&";
    });
    return this.http.get(
      environment.api + this.entity + "/payment-method" + filters,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  mes_factures(more_params?: Array<any>): Observable<any> {
    let filters = "?";
    more_params?.forEach((item) => {
      filters += item.key + "=" + item.value + "&";
    });
    filters += this.authService.currentUserValue?.is_connect_with
      ? "user=" + this.authService.currentUserValue?.id
      : "";
    return this.http.get(
      environment.api + this.entity + "/invoices" + filters,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  remove_payment_card(payment_method_token: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/remove-payment-method",
      { payment_method_token: payment_method_token },
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  create_payment_intent_card() {
    return this.http.post(
      environment.api + this.entity + "/create-setup-intent-card",
      {},
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  attach_card(tokenPaymentMethod: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/attach-card",
      { token_card: tokenPaymentMethod },
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }
}
